export const GET_NOTIFICATION_ALL = 'GET_NOTIFICATION_ALL';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const SET_UNREAD_NOTIFICATION_STATUS = 'SET_UNREAD_NOTIFICATION_STATUS';
